<template>
  <div v-if="$store.state.menu.Courses">
    <v-container fill-height fluid grid-list-xl>
      <Loader :loading="loading" />
      <v-layout justify-center wrap>
        <v-flex md12>
          <material-card
            color="green"
            title="Курс доллара"
            text="Список курса доллара"
          >
            <v-btn color="success" @click="openNews" text> Добавить </v-btn>
       
            <v-data-table :headers="headers" :items="newsList" hide-actions>
              <template slot="headerCell" slot-scope="{ header }">
                <span
                  class="subheading font-weight-light text-success text--darken-3"
                  v-text="header.text"
                />
              </template>
              <template slot="items" slot-scope="{ item }">
                <td
                
                >
                  {{ item.value }}
                </td>
                <td class="text-xs-left">{{ item.created_at | dateTime }}</td>

              </template>
            </v-data-table>

            <v-pagination
              v-if="last_page > 1"
              v-model="page"
              class="my-4"
              :length="last_page"
            ></v-pagination>
          </material-card>
        </v-flex>
      </v-layout>
      <Dealer />
    </v-container>
    <div class="small-dialog">
      <v-dialog width="600" v-if="dialog" v-model="dialog">
        <v-card>
          <v-card-text>
            <v-text-field
              label="Введите курс"
              placeholder="Например: 10900"
              v-model="value"
              outlined
              required
            ></v-text-field>

          </v-card-text>
          <v-divider> </v-divider>
          <v-card-actions class="text-xs-center">
            <v-btn color="success" text @click="setNews">Сохранить </v-btn>
            <v-btn color="primary" text @click="closeNews">Отмена </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import Loader from "../components/helper/Loader";

export default {
  data: () => ({
    loading: true,
    dialog: false,
    page: 1,
    last_page: 0,

    value: "",

    headers: [
      {
        sortable: false,
        text: "Курс",
        value: "value",
      },
      {
        sortable: false,
        text: "Дата создания",
        value: "rate",
      },

   
    ],
    newsList: [],
  }),
  methods: {
    getNews() {
      axios
        .get("admin/courses", {
          params: {
            page: this.page,
          },
        })
        .then((response) => {
          this.newsList = response.data.data;
          this.last_page = response.data.last_page;
          this.loading = false;
        })
        .catch((error) => {});
    },
    setNews() {
      this.loading = true;
      axios
        .post("admin/courses", {
          value: this.value,
        })
        .then((response) => {

    

          this.closeNews();
        })
        .catch((error) => {
          let data = error.response.data;
          if (data.errors) {
            Object.keys(data.errors).forEach((item) => {
              let err = data.errors[item];
              for (let i = 0; i < err.length; i++) {
                this.$toast.error({
                  title: "Ошибка",
                  message: err[i],
                });
              }
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    openNews(newID) {
      if (newID) {
        this.dialog = true;
      }
    },
    closeNews() {
      this.value = "";
      this.dialog = false;
      this.getNews();
    },
  },
  components: { Loader },
  mounted() {
    this.getNews();
  },
  watch: {
    page() {
      setTimeout(() => {
        this.getNews();
      }, 300);
    },
  },
};
</script>

<style>
.active {
  opacity: 1;
}

.no-active {
  opacity: 0.6;
}
</style>
